import { AvailabilityFormData, GeneralInformationFormData, SeasonAvailabilityType, ActiveItem, AmenitiesFormData } from './types';

export const routeToItem = {
    preview: ActiveItem.PREVIEW,
    general: ActiveItem.GENERAL,
    availability: ActiveItem.AVAILABILITY,
    pricing: ActiveItem.PRICING,
    amenities: ActiveItem.AMENITIES,
};

let _itemToRoute = {};
Object.keys(routeToItem).map((k) => {
    const val = routeToItem[k];
    _itemToRoute[val] = k;
});
export const itemToRoute = _itemToRoute;

export const routeToActiveItem = (route: 'general' | 'availability' | 'amenities') => {
    if (Object.keys(routeToItem).indexOf(route) > -1) {
        return routeToItem[route];
    }
    return null;
};

export const activeItemToLinkProps = (item: ActiveItem, venueId?: number) => {
    const routeToken = itemToRoute[item];
    return {
        pathname: `/twsadmin/apps/venue-management/${routeToken}/`,
        search: !!venueId ? `?vid=${venueId}` : undefined,
    };
};

export const defaultGeneralInfoFormData: GeneralInformationFormData = {
    /* About */
    venue_name: '',
    description: '',
    is_wedding_venue: true,
    is_rd_venue: false,
    is_dw_venue: false,

    /* Address */
    address_1: '',
    address_2: '',
    city: '',
    state: '',
    zip_code: '',
    country: 'United States',
    province: '',
    market: '',
    lock_market: false,
    region_1: null,
    lock_region_1: false,
    region_2: null,
    lock_region_2: false,
    is_private_address: false,
    cross_region_market: null,
    lock_cross_region_market: false,
    cross_region: null,
    lock_cross_region: false,

    /* Contacts */
    contacts: [],

    /* Media */
    videos: [{ url: '', order: 1 }],
    wedding_packet_email_subject: null,
    wedding_packet_email_body: null,
    wedding_packet_files_to_upload: [],

    /* Styles */
    styles: [],

    /* Links */
    website_url: null,
    facebook_url: null,
    instagram_url: null,
    pinterest_url: null,
};

export const defaultAvailabilityFormData: AvailabilityFormData = {
    allocated_hours: 8,
    season_availability: SeasonAvailabilityType.ALL_YEAR,
    peak_month_override: [],
    availability_description: '',
    availability_start_time: null,
    availability_end_time: null,
    max_event_hours: null,
    extra_hours_charge_type: null,
    fees_per_extra_hour: null,
};

export const defaultAmenitiesFromData: AmenitiesFormData = {
    amenities: [],
    restrictions: [],
    kitchen_facilities: 1,
    catering_option: 1,
    alcohol_policy: 1,
    smoking_policy: 1,
    music_policy: 1,
    music_end_time: 'None',
    parking_option: 1,
};
